/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class TranslationGrid extends SiteEntityGrid<TranslationRow, any> {
        protected getColumnsKey() { return 'Data.Translation'; }
        protected getDialogType() { return TranslationDialog; }
        protected getIdProperty() { return TranslationRow.idProperty; }
        protected getLocalTextPrefix() { return TranslationRow.localTextPrefix; }
        protected getService() { return TranslationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}